import { useState } from 'react';
import Breadcrumb from '@/components/base/Breadcrumb';

export default function AboutPage() {
  return (
    <main className="min-h-screen pt-20 pb-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-6">
          <Breadcrumb
            items={[
              { label: '首页', path: '/' },
              { label: '关于我们' },
            ]}
          />
        </div>

        <BrandIntro />
        <Reputation />
        <ContactSection />
      </div>
    </main>
  );
}

function BrandIntro() {
  return (
    <section className="mb-16">
      <div className="text-center mb-10">
        <span className="inline-block bg-primary-100 text-primary-700 text-xs font-medium px-3 py-1 rounded-full mb-3">
          品牌介绍
        </span>
        <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
          关于麻豆视频
        </h1>
        <p className="text-sm text-foreground-600 max-w-2xl mx-auto leading-relaxed">
          麻豆视频是备受关注的原创高清内容平台，致力于为用户提供丰富优质的影视娱乐资源
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center mb-12">
        <div>
          <h2 className="text-xl font-heading font-bold text-foreground-900 mb-4">我们的故事</h2>
          <p className="text-sm text-foreground-700 leading-relaxed mb-4">
            麻豆视频创立于2020年，由一群热爱影视创作的专业人士共同发起。创始团队拥有丰富的影视制作和互联网产品经验，怀着"让每个人都能享受高品质原创内容"的初心，开启了这段精彩的创业旅程。
          </p>
          <p className="text-sm text-foreground-700 leading-relaxed mb-4">
            经过多年的深耕发展，麻豆视频已经从一个小型内容社区成长为涵盖剧情大片、喜剧综艺、纪录纪实、音乐现场、生活时尚、科技数码等六大内容品类的综合性高清内容平台。平台累计上线超过5000部原创高清内容，覆盖多种类型和题材。
          </p>
          <p className="text-sm text-foreground-700 leading-relaxed">
            我们始终坚持以内容质量为核心，以用户需求为导向，不断优化产品体验，丰富内容生态。目前，麻豆视频已经拥有超过200万日活跃用户，入驻创作者超过10万人，成为国内领先的原创高清内容平台之一。
          </p>
        </div>
        <div className="aspect-[4/3] rounded-xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Modern%20creative%20office%20space%20with%20warm%20lighting%2C%20team%20collaboration%20atmosphere%2C%20video%20production%20equipment%20in%20background%2C%20casual%20professional%20environment%2C%20natural%20light%20through%20large%20windows%2C%20creative%20studio%20aesthetic&width=800&height=600&seq=about-brand-01&orientation=landscape"
            alt="麻豆视频团队办公场景"
            title="麻豆视频 - 办公环境"
            className="w-full h-full object-cover object-top"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {[
          {
            icon: 'ri-focus-3-line',
            title: '我们的使命',
            desc: '打造中国领先的高清原创内容平台，让优质内容触手可及，让每一位创作者都能获得应有的尊重和回报。',
          },
          {
            icon: 'ri-lightbulb-line',
            title: '我们的愿景',
            desc: '成为全球华语原创内容的首选平台，引领高清内容创作和消费的新趋势，推动文化产业数字化升级。',
          },
          {
            icon: 'ri-heart-line',
            title: '核心价值观',
            desc: '内容为王、用户至上、创新驱动、合作共赢。我们坚信优质内容是最核心的竞争力，用户体验是最好的衡量标准。',
          },
        ].map((item, index) => (
          <div key={index} className="bg-background-100/50 rounded-xl p-6 border border-background-200/60">
            <div className="w-11 h-11 rounded-lg bg-primary-100 flex items-center justify-center mb-4">
              <i className={`${item.icon} text-primary-600 text-lg w-5 h-5 flex items-center justify-center`}></i>
            </div>
            <h3 className="text-base font-semibold text-foreground-900 mb-2">{item.title}</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

function Reputation() {
  return (
    <section className="mb-16 py-14 bg-background-100/50 -mx-4 md:-mx-6 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block bg-secondary-100 text-secondary-700 text-xs font-medium px-3 py-1 rounded-full mb-3">
            口碑评价
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            行业认可与用户信赖
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            麻豆视频凭借优质的内容和服务，赢得了行业和用户的广泛认可
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {[
            {
              title: '2025年度最佳原创内容平台',
              source: '中国数字内容产业协会',
              date: '2025年12月',
              desc: '凭借卓越的原创内容质量和用户增长表现，麻豆视频荣获2025年度最佳原创内容平台称号。评委会高度评价了平台在内容精品化、技术创新和用户体验方面的突出贡献。',
            },
            {
              title: '用户满意度金奖',
              source: '中国互联网协会',
              date: '2025年10月',
              desc: '在2025年度互联网产品用户满意度评选中，麻豆视频以99.7%的用户满意度获得视频内容类产品金奖。这一荣誉来自真实用户的评价和认可。',
            },
            {
              title: '最佳创作者生态平台',
              source: '中国网络视听协会',
              date: '2025年8月',
              desc: '麻豆视频在创作者扶持、内容分成、创作工具等维度表现优异，被评为年度最佳创作者生态平台。平台为超过10万创作者提供了良好的创作和成长环境。',
            },
            {
              title: '科技创新先锋企业',
              source: '中关村科技园区',
              date: '2025年6月',
              desc: '麻豆视频在视频编码技术、推荐算法、AI内容理解等方面的创新成果获得认可，被授予科技创新先锋企业称号。技术团队拥有多项自主知识产权和发明专利。',
            },
          ].map((item, index) => (
            <div key={index} className="bg-background-50 rounded-xl p-6 border border-background-200/60">
              <div className="flex items-start gap-3 mb-3">
                <div className="w-8 h-8 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-award-line text-accent-600 w-4 h-4 flex items-center justify-center"></i>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-900">{item.title}</h3>
                  <div className="flex items-center gap-2 mt-1">
                    <span className="text-xs text-foreground-500">{item.source}</span>
                    <span className="text-xs text-foreground-400">·</span>
                    <span className="text-xs text-foreground-400">{item.date}</span>
                  </div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function ContactSection() {
  const [formStatus, setFormStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formMsg, setFormMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.querySelector('[name="mobile_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setFormStatus('success');
      setFormMsg('消息已发送，我们会尽快回复！');
      return;
    }

    setFormStatus('loading');
    try {
      const formData = new FormData(form);
      const res = await fetch('https://readdy.ai/api/form/d9u40qtca23r0tr1aq20', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const text = await res.text();
      let parsed;
      try { parsed = JSON.parse(text); } catch { parsed = null; }
      if (res.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        setFormMsg('消息已发送成功，我们的客服团队将在24小时内与您联系！');
        form.reset();
      } else {
        const errMsg = parsed?.meta?.message || parsed?.message || '发送失败，请稍后再试';
        setFormStatus('error');
        setFormMsg(errMsg);
      }
    } catch {
      setFormStatus('error');
      setFormMsg('网络错误，请检查连接后重试');
    }
  };

  return (
    <section>
      <div className="text-center mb-10">
        <span className="inline-block bg-primary-100 text-primary-700 text-xs font-medium px-3 py-1 rounded-full mb-3">
          联系我们
        </span>
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
          期待听到您的声音
        </h2>
        <p className="text-sm text-foreground-600 max-w-xl mx-auto">
          如有任何问题或合作意向，欢迎随时与我们取得联系
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-5 gap-8">
        <div className="lg:col-span-3">
          <form onSubmit={handleSubmit} data-readdy-form="" className="bg-background-100/50 rounded-xl p-6 border border-background-200/60">
            <input
              type="text"
              name="mobile_alt"
              tabIndex={-1}
              autoComplete="off"
              readOnly
              aria-hidden="true"
              className="honeypot-field"
            />
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
              <div>
                <label className="block text-sm font-medium text-foreground-700 mb-1.5">姓名 <span className="text-primary-500">*</span></label>
                <input
                  type="text"
                  name="name"
                  required
                  placeholder="请输入您的姓名"
                  className="w-full px-3 py-2.5 bg-background-50 border border-background-200 rounded-lg text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-foreground-700 mb-1.5">邮箱 <span className="text-primary-500">*</span></label>
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="请输入您的邮箱"
                  className="w-full px-3 py-2.5 bg-background-50 border border-background-200 rounded-lg text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                />
              </div>
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium text-foreground-700 mb-1.5">主题 <span className="text-primary-500">*</span></label>
              <input
                type="text"
                name="subject"
                required
                placeholder="请输入消息主题"
                className="w-full px-3 py-2.5 bg-background-50 border border-background-200 rounded-lg text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
              />
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium text-foreground-700 mb-1.5">消息内容 <span className="text-primary-500">*</span></label>
              <textarea
                name="message"
                required
                rows={5}
                maxLength={500}
                placeholder="请输入您想说的内容（最多500字）"
                className="w-full px-3 py-2.5 bg-background-50 border border-background-200 rounded-lg text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors resize-none"
              ></textarea>
            </div>

            <button
              type="submit"
              disabled={formStatus === 'loading'}
              className="bg-primary-500 hover:bg-primary-600 disabled:opacity-60 text-background-50 px-6 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              {formStatus === 'loading' ? '发送中...' : '发送消息'}
            </button>

            {formStatus !== 'idle' && (
              <p className={`mt-4 text-sm ${formStatus === 'success' ? 'text-green-600' : 'text-red-500'}`}>
                {formMsg}
              </p>
            )}
          </form>
        </div>

        <div className="lg:col-span-2 space-y-5">
          <div className="bg-background-100/50 rounded-xl p-6 border border-background-200/60">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center">
                <i className="ri-mail-line text-primary-600 text-lg w-5 h-5 flex items-center justify-center"></i>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-foreground-900">电子邮箱</h3>
                <p className="text-xs text-foreground-500">商务合作与媒体咨询</p>
              </div>
            </div>
            <p className="text-sm text-foreground-700 pl-13">contact@zhxnfyygl.cn</p>
          </div>

          <div className="bg-background-100/50 rounded-xl p-6 border border-background-200/60">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center">
                <i className="ri-phone-line text-primary-600 text-lg w-5 h-5 flex items-center justify-center"></i>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-foreground-900">客服热线</h3>
                <p className="text-xs text-foreground-500">7×24小时在线服务</p>
              </div>
            </div>
            <p className="text-sm text-foreground-700 pl-13">400-888-8888</p>
          </div>

          <div className="bg-background-100/50 rounded-xl p-6 border border-background-200/60">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center">
                <i className="ri-map-pin-line text-primary-600 text-lg w-5 h-5 flex items-center justify-center"></i>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-foreground-900">公司地址</h3>
                <p className="text-xs text-foreground-500">总部办公地点</p>
              </div>
            </div>
            <p className="text-sm text-foreground-700 pl-13">北京市朝阳区科技园区创新路88号<br />麻豆大厦15层</p>
          </div>

          <div className="bg-background-100/50 rounded-xl p-6 border border-background-200/60">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center">
                <i className="ri-time-line text-primary-600 text-lg w-5 h-5 flex items-center justify-center"></i>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-foreground-900">工作时间</h3>
                <p className="text-xs text-foreground-500">客户服务时间</p>
              </div>
            </div>
            <p className="text-sm text-foreground-700 pl-13">
              周一至周五：9:00 - 21:00<br />
              周六至周日：10:00 - 18:00
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}